<template>
  <form class="vr360-app-main__new-stream" @submit.prevent="submitForm">
    <app-output/>

    <button class="vr360-btn vr360-btn--cut" type="button" @click="share">
      <span>Share link</span>
    </button>

    <ul class="vr360-app__radio-list">
      <!-- <li class="vr360-app__radio-list__item">
        <div class="vr360-input-radio">
          <p class="vr360-head-h4 vr360-text-gray-2 vr360-input-radio__title">Quality</p>
          <div class="vr360-input-radio__block">
            <label>
              <input type="radio" name="quality" :value="false" v-model="stream.quality">
              <span class="vr360-head-h4">4k</span>
              <p></p>
            </label>
            <label>
              <input type="radio" name="quality" :value="true" v-model="stream.quality">
              <span class="vr360-head-h4">8k</span>
            </label>
          </div>
        </div>
      </li> -->

      <!-- <li class="vr360-app__radio-list__item">
        <div class="vr360-input-radio">
          <p class="vr360-head-h4 vr360-text-gray-2 vr360-input-radio__title">Sound</p>
          <div class="vr360-input-radio__block">
            <label>
              <input type="radio" name="sound" :value="true" v-model="stream.sound">
              <span class="vr360-head-h4">On</span>
              <p></p>
            </label>
            <label>
              <input type="radio" name="sound" :value="false" v-model="stream.sound">
              <span class="vr360-head-h4">Off</span>
            </label>
          </div>
        </div>
      </li> -->

      <li class="vr360-app__radio-list__item">
        <div class="vr360-input-radio">
          <p class="vr360-head-h4 vr360-text-gray-2 vr360-input-radio__title">Private stream</p>
          <div class="vr360-input-radio__block">
            <label>
              <input type="radio" name="private" :value="true" v-model="stream.private">
              <span class="vr360-head-h4">Yes</span>
              <p></p>
            </label>
            <label>
              <input type="radio" name="private" :value="false" v-model="stream.private">
              <span class="vr360-head-h4">No</span>
            </label>
          </div>
        </div>
      </li>
    </ul>

    <div>
      <div class="vr360-stream-stub vr360-app__stream__main__poster">
        <img v-if="blob" :src="blob" alt>
      </div>
      <label class="vr360-btn vr360-btn--cut">
        <span>Add video cover</span>
        <input type="file" accept=".jpg, .jpeg, .png" hidden @change="uploadPoster">
      </label>
    </div>

    <app-textarea
      v-model="stream.title"
      :placeholder="'Stream name'"
      :errorMessage="'message'"
      :showErrorMessage="false"
    />

    <app-textarea
      v-model="stream.description"
      :placeholder="'Description (optional)'"
      :errorMessage="'message'"
      :showErrorMessage="false"
    />

    <button type="submit" class="vr360-btn vr360-btn--red vr360-app-main__go-live-btn">
      <span>Go live</span>
    </button>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import appTextarea from "../partials/TextArea";
import appOutput from "../partials/Output";

// import setts from "@/config/url";
import resizerImg from "@/assets/js/resizeImg";

export default {
  name: "createStream",
  components: {
    appTextarea,
    appOutput
  },
  data() {
    return {
      stream: {
        title: "",
        description: "",
        private: true,
        quality: false,
        sound: true,
        poster: null
      },
      blob: null
    };
  },
  created() {
    this.getLink();
  },
  mounted() {
    if (this.getScrollBlock) {
      this.getScrollBlock.scrollTop = 0;
    }
  },
  methods: {
    ...mapActions({
      getLink: "stream/getLink",
      create: "stream/storeStream",
      showNotification: "showNotification"
    }),
    uploadPoster(event) {
      let target = event.target;
      let uploadedFile = target.files[0];

      if (uploadedFile.type.split("/")[0] === "image") {
        this.showThumbImg(uploadedFile);
      } else {
        target.value = "";

        this.showNotification({
          type: "error",
          message: "Can't upload file"
        });
      }
    },
    resizeImg(img) {
      const that = this;

      resizerImg(img, {
        max_height: 230,
        max_width: 384,
        callBack: (src, resultFile) => {
          that.stream.poster = resultFile;
          that.blob = src;
        }
      });
    },
    showThumbImg(file) {
      let img = new Image();
      img.onload = this.resizeImg.bind(null, img);
      img.src = URL.createObjectURL(file);
    },
    submitForm() {
      this.stream = { ...this.currentStream, ...this.stream };
      this.create(this.stream);
    },
    share() {
      if ("share" in navigator) {
        navigator.share({
          title: "Mecha VR360HF",
          text: "Stream to share with the URL",
          // url: this.currentStream.link_hls
          url:
            window.location.origin +
            "/shared-stream/" +
            this.currentStream.token_shared
        });
      } else {
        this.$copyText(
          window.location.origin +
            "/shared-stream/" +
            this.currentStream.token_shared
        ).then(
          () => {
            this.showNotification({
              type: "success",
              message: "Copied!"
            });
          },
          () => {
            this.showNotification({
              type: "error",
              message: "Can`t copy url"
            });
          }
        );
      }
    }
  },
  computed: {
    ...mapGetters({
      currentStream: "stream/currentStream",
      getScrollBlock: "getScrollBlock"
    })
  }
};
</script>

<style lang="scss">
</style>
